module.exports = "https://deal-img.imgix.net/consumer/favicon-16x16.30211592.png";